import { useEffect, useState } from "react";

const allDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export function useSubsidyControl(enabledDays) {
  const [dailySubsidy, setDailySubsidy] = useState(() =>
    allDays?.reduce((acc, day) => {
      acc[day] = "";
      return acc;
    }, {})
  );

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setDailySubsidy((prev) =>
      allDays.reduce((acc, day) => {
        acc[day] = enabledDays?.includes(day) ? prev[day] : ""; // clear if unselected
        return acc;
      }, {})
    );

    // Reset errors when selection changes
    setErrors((prev) =>
      allDays.reduce((acc, day) => {
        acc[day] = enabledDays?.includes(day) ? prev[day] || false : false;
        return acc;
      }, {})
    );
  }, [enabledDays]);

  const onChangeDaily = (value, day) => {
    setDailySubsidy((prev) => ({ ...prev, [day]: value }));
    setErrors((prev) => ({ ...prev, [day]: false }));
  };

  const isDayEnabled = (day) => enabledDays?.includes(day);

  const validate = () => {
    const newErrors = {};
    let isValid = true;

    enabledDays?.forEach((day) => {
      const value = dailySubsidy[day];
      if (value === undefined || value === null || value === "") {
        newErrors[day] = true;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const resetSubsidy = () => {
    setDailySubsidy(
      allDays.reduce((acc, day) => {
        acc[day] = "";
        return acc;
      }, {})
    );
    setErrors({});
  };

  const setSubsidyManually = (obj) => {
    const full = allDays.reduce((acc, day) => {
      acc[day] = obj?.[day] ?? "";
      return acc;
    }, {});
    setDailySubsidy(full);
    setErrors({});
  };

  return {
    dailySubsidy,
    onChangeDaily,
    isDayEnabled,
    errors,
    validate,
    resetSubsidy,
    setSubsidyManually,
  };
}
